function initSliderVideo() {
    let swiper = new Swiper(".slide-video", {
    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
        992: {
            slidesPerView: 3,
        },
        450: {
            slidesPerView: 2,
        }
    },
    pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    });
}
initSliderVideo();
